import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class UserSectionsStatsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'UserSectionsStatsStateModel';
    statsPercentage: number = null;

    constructor() {
        super(UserSectionsStatsStateModel.identifier);
    }
}
